<template>
<header id="header-dep" class="headroom" role="banner">

  <div class="container-fluid dep-skip-navigation" id="dep-skip-navigation" role="menubar">
    <div class="container">
      <ul class="list-inline">
        <li class="list-inline-item" role="menuitem"><a href="#dep49-contenu" class="skip">Aller au contenu</a></li>
        <li class="list-inline-item" role="menuitem"><a href="#dep49-menu" class="skip">Aller au menu</a></li>
        <li class="list-inline-item" role="menuitem"><a href="#dep49-recherche" class="skip">Aller à la recherche</a></li>
        <li class="list-inline-item" role="menuitem"><a href="#" id="headerDyslexia">Dyslexie</a></li>
        <li class="list-inline-item" role="menuitem"><a href="#" id="headerContrast">Contraste</a></li>
      </ul>
    </div>
  </div>

  <!--
    <div class="container-fluid dep-menu-share collapse" id="dep-menu-share">
    </div>
  -->

  <b-collapse id="dep-menu-share">
    <div class="container">
      <p>Suivez-nous sur les réseaux sociaux : </p>
      <ul class="list-inline dep-social-networks">
        <li class="list-inline-item">
          <a href="https://www.facebook.com/Departement49" target="_blank" title="Page Facebook du Département de Maine-et-Loire [nouvelle fenêtre]">
            <span class="dep49-icon-facebook" aria-hidden="true" data-glyph="icon-facebook"></span>
            <span class="sr-only sr-only-focusable">Page Facebook du Département de Maine-et-Loire</span>
          </a>
        </li>
        <li class="list-inline-item">
          <a href="https://twitter.com/Maine_et_Loire" target="_blank" title="Compte Twitter du Département de Maine-et-Loire [nouvelle fenêtre]">
            <span class="dep49-icon-twitter" aria-hidden="true" data-glyph="icon-twitter"></span>
            <span class="sr-only sr-only-focusable">Compte Twitter du Département de Maine-et-Loire</span>
          </a>
        </li>
        <li class="list-inline-item">
          <a href="https://www.instagram.com/maine_et_loire/" target="_blank" title="Compte Instagram du Département de Maine-et-Loire [nouvelle fenêtre]">
            <span class="dep49-icon-instagram" aria-hidden="true" data-glyph="icon-instagram"></span>
            <span class="sr-only sr-only-focusable">Compte Instagram du Département de Maine-et-Loire</span>
          </a>
        </li>
        <li class="list-inline-item">
          <a href="https://www.youtube.com/channel/UCbwP1_VTPU2N6ztytUV76qg" target="_blank" title="Page Youtube du Département de Maine-et-Loire [nouvelle fenêtre]">
            <span class="dep49-icon-youtube" aria-hidden="true" data-glyph="icon-youtube">
            </span>
            <span class="sr-only sr-only-focusable">Page Youtube du Département de Maine-et-Loire</span>
          </a>
        </li>
      </ul>
    </div>
  </b-collapse>

  <div class="container-fluid dep-navigation">
    <div class="container">
      <div class="logo-anjou">
        <a href="https://www.maine-et-loire.fr" target="_blank" title="Département de Maine-et-Loire - Anjou : aller à la page d'accueil du site maine-et-loire.fr (Nouvelle fenêtre)">
            <span class="dep49-icon-logo-anjou" aria-hidden="true" data-glyph="icon-logo-anjou" title="Logo Anjou - Département de Maine-et-Loire"></span>
        </a>
      </div>



      <ul class="nav nav-inline" role="navigation">
        <li class="nav-item">
          <a class="nav-link" href="https://www.maine-et-loire.fr/aides-et-services" target="_blank" title="Rubrique Aides et services du site www.maine-et-loire.fr (Nouvelle fenêtre)">Aides et services</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="https://www.maine-et-loire.fr/conseil-departemental/" target="_blank" title="Rubrique Conseil départemental du site www.maine-et-loire.fr (Nouvelle fenêtre)">Conseil départemental</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="https://www.maine-et-loire.fr/actualites/" target="_blank" title="Rubrique Actualités du site www.maine-et-loire.fr (Nouvelle fenêtre)">Actualités</a>
        </li>

        <li class="nav-item">
          <b-dropdown id="dep-autres-sites" text="Nos sites web" class="nav-link">
            <div class="container sitesdep subLevel0">
              <ul class="subLevel1 active">
                <li>
                  Culture
                  <div class="subLevel2">
                    <ul class="active">   
                      <li><a href="https://www.archives49.fr" class="dropdown-item" target="_blank" rel="noreferrer" title="Site Internet des Archives départementales (Nouvelle fenêtre)">Archives départementales</a></li>   
                      <li><a href="https://www.collegiale-saint-martin.fr/" class="dropdown-item" target="_blank" rel="noreferrer" title="Site Internet de la Collégiale Saint-Martin (Nouvelle fenêtre)">Collégiale Saint-Martin</a></li>    
                      <li><a href="https://bibliopole.maine-et-loire.fr/" class="dropdown-item" target="_blank" rel="noreferrer" title="Site Bibliopôle (Nouvelle fenêtre)">Bibliopôle</a></li>    
                    </ul>
                  </div>
                </li>
                <li>
                  Déplacements   
                  <div class="subLevel2">
                    <ul class="active">      
                      <li><a href="https://www.ouestgo.fr/" class="dropdown-item" target="_blank" rel="noreferrer" title="Site Internet OuestGo (Nouvelle fenêtre)">Covoiturage</a></li>   
                      <li><a href="https://www.inforoutes49.fr/" class="dropdown-item" target="_blank" rel="noreferrer" title="Site Internet Inforoutes49 (Nouvelle fenêtre)">Inforoutes49</a></li>     
                    </ul>
                  </div>
                </li>
                <li>
                  Services    
                  <div class="subLevel2">
                    <ul class="active">    
                      <li><a href="https://www.anjoumarchespublics.fr/" class="dropdown-item" target="_blank" rel="noreferrer" title="Site Internet Anjou marchés publics (Nouvelle fenêtre)">Anjou Marchés publics</a></li> 
                      <li><a href="https://anjou.e-lyco.fr/" class="dropdown-item" target="_blank" rel="noreferrer" title="Site Internet E-Lyco (Nouvelle fenêtre)">E-Lyco</a></li>    
                      <li><a href="https://data.maine-et-loire.fr/" class="dropdown-item" target="_blank" rel="noreferrer" title="Site Internet data.maine-et-loire.fr (Nouvelle fenêtre)">Données publiques</a></li>    
                      <li><a href="https://participons.maine-et-loire.fr/" class="dropdown-item" target="_blank" rel="noreferrer" title="Site Internet de participation citoyenne (Nouvelle fenêtre)">Participation citoyenne</a></li> 
                    </ul>
                  </div>
                </li>
                <li>
                  Solidarités   
                  <div class="subLevel2">
                    <ul class="active">
                      <li><a href="https://www.assistantsmaternels49.fr/" class="dropdown-item" target="_blank" rel="noreferrer" title="Assistants maternels 49 (Nouvelle fenêtre)">Assistants maternels</a></li>
                      <li><a href="https://jobanjou.maine-et-loire.fr" class="dropdown-item" target="_blank" rel="noreferrer" title="Jobanjou (Nouvelle fenêtre)">Jobanjou</a></li>      
                      <li><a href="https://www.mda.maine-et-loire.fr/" class="dropdown-item" target="_blank" rel="noreferrer" title="Site Internet de la Maison de l'Autonomie (Nouvelle fenêtre)">Maison de l'Autonomie</a></li>    
                      <li><a href="https://insertion.maine-et-loire.fr/" class="dropdown-item" target="_blank" rel="noreferrer" title="Portail Insertion (Nouvelle fenêtre)">Portail Insertion</a></li>   
                       
                    </ul>
                  </div>
                </li>
                <li>
                  Territoire   
                  <div class="subLevel2">
                    <ul class="active">      
                      <li><a href="https://www.eau-anjou.fr/" class="dropdown-item"target="_blank" rel="noreferrer" title="Site Internet de l'Observatoire de l'eau (Nouvelle fenêtre)">Observatoire de l'eau</a></li>    
                      <li><a href="http://www.produitenanjou.fr" class="dropdown-item" target="_blank" rel="noreferrer" title="Site Internet Produit en Anjou (Nouvelle fenêtre)">Produit en Anjou</a></li>
                      <li><a href="https://www.parlonsdanjou.fr/" class="dropdown-item" target="_blank" rel="noreferrer" title="Site Internet Parlons d'Anjou (Nouvelle fenêtre)">Rayonnement de l'Anjou</a></li>
                      <li><a href="https://sentiers.maine-et-loire.fr/" class="dropdown-item" target="_blank" rel="noreferrer" title="Site Internet Sentiers nature (Nouvelle fenêtre)">Sentiers nature</a></li>    
                      <li><a href="https://www.terrabotanica.fr/" class="dropdown-item" target="_blank" rel="noreferrer" title="Site Internet de Terra Botanica (Nouvelle fenêtre)">Terra Botanica</a></li> 
                      <li><a href="https://www.wiki-anjou.fr/" class="dropdown-item" target="_blank" rel="noreferrer" title="Wiki-Anjou (Nouvelle fenêtre)">Wiki-Anjou</a></li>  
                    </ul>
                  </div>
                </li>
              </ul>
              <b-dropdown-item class="btn btn-fermer">
                  Fermer le menu<span class="dep49-icon-close" aria-hidden="true" data-glyph="icon-close" title="Fermer le menu Actualités"></span>
              </b-dropdown-item>
            </div>
          </b-dropdown>
        </li>
      </ul>

      <b-btn v-b-toggle.dep-menu-share class="dep-menu-share">
        <span class="dep49-icon-share" aria-hidden="true" data-glyph="icon-share" title="Ouvrir / Fermer le menu de partage sur les réseaux sociaux" ></span>
        <span class="dep49-icon-arrow-up" aria-hidden="true" data-glyph="icon-arrow-up" title="Ouvrir le menu de partage sur les réseaux sociaux"></span>
        <span class="dep49-icon-arrow-down" aria-hidden="true" data-glyph="icon-arrow-down" title="Fermer le menu de partage sur les réseaux sociaux"></span>
        <span class="sr-only sr-only-focusable">Ouvrir / Fermer le menu de partage sur les réseaux sociaux</span>
      </b-btn>

    </div>
  </div>

</header>
</template>

<script>
export default {
  name: 'header-dep'
}
</script>

<style src="../node_modules/bootstrap-vue-dep49/dist/bootstrap-vue.css"></style>
<style lang="scss" src="./scss/dep49-header-footer-main.scss"></style>
<style lang="scss">
#dep-autres-sites > a > button.btn {
    font-family: "Century Gothic", "Times New Roman", serif;
    background-color: rgb(68, 68, 68);
    color: white;
    border: 0px;
    font-weight: 700;
    font-size: 0.8rem !important;
}
</style>



// WEBPACK FOOTER //
// Header.vue?6a515cf6